import {
  NotificationReadModel,
  NotificationType,
  WorkflowOverdueMessage,
  WorkflowReminder,
} from '@/client/services/api/graphql/gql/graphql';

import { extractNotificationMessage } from '@/client/components/admin/assignments/builder/forms/notifications/utils/extractNotificationMessage';
import { useTranslation } from 'react-i18next';

export const useSetNotificationTimeframe = () => {
  const setNotificationTimeframe = (
    notification: NotificationReadModel | WorkflowReminder | WorkflowOverdueMessage,
  ) => {
    const { t } = useTranslation();

    const message = extractNotificationMessage(notification);

    if (!message) return '--';

    if (
      message.type === NotificationType.AssignmentReminderAssignee ||
      message.type === NotificationType.AssignmentReminderEscalator
    ) {
      if (!('timeBeforeDue' in notification)) {
        return '--';
      }

      const days = notification.timeBeforeDue;

      if (!days) return '--';

      return `${days} ${
        days > 1
          ? t('assignmentMessaging.before_due_date.days')
          : t('assignmentMessaging.before_due_date.day')
      } ${t('assignmentMessaging.before_due_date')}`;
    }

    if (
      message.type === NotificationType.AssignmentCreatedAssignee ||
      message.type === NotificationType.AssignmentCreatedEscalator
    ) {
      return t('assignmentMessaging.upon_assignment');
    }

    if (
      message.type === NotificationType.AssignmentPassedAssignee ||
      message.type === NotificationType.AssignmentPassedEscalator
    ) {
      return t('assignmentMessaging.upon_completion');
    }

    if (
      message.type === NotificationType.AssignmentFailedAssignee ||
      message.type === NotificationType.AssignmentFailedEscalator
    ) {
      return t('assignmentMessaging.past_due_date');
    }

    if (message.type === NotificationType.AssignmentOverdueAssignee) {
      return t('assignmentMessaging.overdue');
    }

    return '--';
  };

  return { setNotificationTimeframe };
};
